module.exports = __webpack_public_path__ + "img/silver4.20e2495f.png";